




















































































import Vue from 'vue';

import PriceInput from '@/vue/components/input/Price.vue';
import { Entry } from './types';
import Decimal from 'decimal.js';

export enum SHOW_PRICES {
  LAST = 0x1,
  PROMO = 0x2,
  REF = 0x4,
  MIN = 0x8,
  MAX = 0x10,
}

export default Vue.extend({
  components: {
    'input-price': PriceInput,
  },

  data() {
    return {
      isEdit: false,
    };
  },
  props: {
    currency: {
      type: String as () => string,
      required: true,
    },
    data: Object as () => Entry | null,
    showPrice: {
      type: Number as () => number,
      default: 0,
    },
    taskDate: {
      type: String as () => string,
      required: true,
    },
    updatePrice: {
      type: Function,
    },
  },
  computed: {
    currPrice(): string {
      const price = this.data!.currPrice;
      if (price === null) {
        return '-';
      }

      return `${(price / 100).toFixed(2)}`;
    },

    hasPhoto(): boolean {
      return this.data!.attachments.length > 0;
    },

    isApproved(): boolean {
      return this.data!.approvedAt !== null;
    },

    isOos(): boolean {
      return this.data!.isOos || false;
    },

    isInStorePromo(): boolean {
      return this.data!.isPromo || false;
    },

    isPromo(): boolean {
      // no need to show is promo if promo has ended
      if (this.isPromoEnd) {
        return false;
      }

      return this.data!.promoPrice !== null;
    },

    isPromoEnd(): boolean {
      if (!this.data) {
        return false;
      }

      const tillDate = this.data.promotionTill;
      if (tillDate && this.taskDate > tillDate) {
        return true;
      }

      return false;
    },

    lastPrice(): string {
      const price = this.data!.lastPrice;
      if (price === null) {
        return '-';
      }
      return `${this.currency} ${(price / 100).toFixed(2)}`;
    },

    maxPrice(): string {
      const price = this.data!.maxPrice;
      if (price === null) {
        return '-';
      }
      return `${this.currency} ${(price / 100).toFixed(2)}`;
    },

    minPrice(): string {
      const price = this.data!.minPrice;
      if (price === null) {
        return '-';
      }
      return `${this.currency} ${(price / 100).toFixed(2)}`;
    },

    note(): string | null {
      return this.data!.noteAuditor;
    },

    promoPrice(): string {
      const price = this.data!.promoPrice;
      if (price === null) {
        return '-';
      }
      return `${this.currency} ${(price / 100).toFixed(2)}`;
    },

    refPrice(): string {
      const price = this.data!.refPrice;
      if (price === null) {
        return '-';
      }

      return `${this.currency} ${(price / 100).toFixed(2)}`;
    },

    showLastPrice(): boolean {
      const { showPrice } = this;
      // tslint:disable-next-line no-bitwise
      return (showPrice & SHOW_PRICES.LAST) === SHOW_PRICES.LAST;
    },

    showMaxPrice(): boolean {
      const { showPrice } = this;
      // tslint:disable-next-line no-bitwise
      return (showPrice & SHOW_PRICES.MAX) === SHOW_PRICES.MAX;
    },

    showMinPrice(): boolean {
      const { showPrice } = this;
      // tslint:disable-next-line no-bitwise
      return (showPrice & SHOW_PRICES.MIN) === SHOW_PRICES.MIN;
    },

    showPromoPrice(): boolean {
      const { showPrice } = this;
      // tslint:disable-next-line no-bitwise
      return (showPrice & SHOW_PRICES.PROMO) === SHOW_PRICES.PROMO;
    },

    showRefPrice(): boolean {
      const { showPrice } = this;
      // tslint:disable-next-line no-bitwise
      return (showPrice & SHOW_PRICES.REF) === SHOW_PRICES.REF;
    },
  },

  methods: {
    onViewMore() {
      if (!this.data) {
        return;
      }
      const entryId = this.data.id;
      const outletId = this.data.outletId;
      this.$emit('view-more', { entryId, outletId });
    },
  },
});
